import { render, staticRenderFns } from "./wheel_updated.vue?vue&type=template&id=0d43c936&scoped=true"
import script from "./wheel_updated.vue?vue&type=script&lang=js"
export * from "./wheel_updated.vue?vue&type=script&lang=js"
import style0 from "./wheel_updated.vue?vue&type=style&index=0&id=0d43c936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d43c936",
  null
  
)

export default component.exports